export const CARD_INFO = {
    1: {
        'headline': 'Cronici',
        'color': 'blue'
    },
    2: {
        'headline': 'Stiri',
        'color': 'green'
    },
    3: {
        'headline': 'Avanpremiera',
        'color': 'pink'
    },
    4: {
        'headline': 'Festival',
        'color': 'yellow'
    }
};

export const monthNames = [
    "Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie",
    "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"
];

export const defaultLocation = "Bucuresti";


// WEBPACK FOOTER //
// ./src/SHARED/config/config.js